import { useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { sportTypes } from '../contexts/SportContext';

export const useViewMode = (user) => {
    const { t } = useTranslation();
    const [viewMode, setViewMode] = useState('all'); // 'all' | 'my' | 'today'

    const cycleViewMode = () => {
        setViewMode(prev => {
            if (prev === 'all') return 'my';
            if (prev === 'my') return 'today';
            return 'all';
        });
    };

    const viewModeIcon = useMemo(() => {
        if (viewMode === 'all') return '🌐';
        if (viewMode === 'my') return sportTypes[user?.favorite_sport]?.icon || '⭐';
        return '📅';
    }, [viewMode, user?.favorite_sport]);

    const viewModeText = useMemo(() => {
        if (viewMode === 'all') return t('all_gonkles_button');
        if (viewMode === 'my') return t('my_gonkle_button');
        return t('today_gonkles_button');
    }, [viewMode, t]);

    return {
        viewMode,
        setViewMode,
        cycleViewMode,
        viewModeIcon,
        viewModeText,
    };
};